import { useEffect, useState } from "react"
import { FlowCommand } from "./FlowCommand"
import { CommandDialog } from "../../ui/Command"

export function FlowCommandMenu() {
    const [open, setOpen] = useState(false)
   
    useEffect(() => {
      const down = (e: KeyboardEvent) => {
        if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
          e.preventDefault()
          setOpen((open) => !open)
        }
      }
      document.addEventListener("keydown", down)
      return () => document.removeEventListener("keydown", down)
    }, [])

    function close() {
        setOpen(false)
    }
   
    return (
      <CommandDialog open={open} onOpenChange={setOpen}>
        <FlowCommand onClose={close}/>
      </CommandDialog>
    )
}